import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '@/components/layout/ProtectedRoute';

const BillingListPage = lazy(() => import('./BillingListPage'));
const InvoiceDetailPage = lazy(() => import('./InvoiceDetailPage'));

export const billingRoutes: RouteObject[] = [
  {
    path: 'billing',
    element: (
      <ProtectedRoute action="billing:view">
        <BillingListPage />
      </ProtectedRoute>
    ),
  },
  {
    path: 'billing/invoices/:id',
    element: (
      <ProtectedRoute action="billing:view">
        <InvoiceDetailPage />
      </ProtectedRoute>
    ),
  },
];
